module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-3-1-7521ffbb0384cb4edd11251ea99fcde2.jpg";